import {SafeRecord} from '../../types/SafeRecord';
import {DANGEROUS_KEYS} from './DANGEROUS_KEYS';

// TypeScript overloads require multiple `function getSafely` declarations merged by the compiler.
// ESLint `no-redeclare` treats each signature as a duplicate binding and does not model TS overload merging.
/* eslint-disable no-redeclare -- intentional TS function overloads */
export function getSafely<T extends SafeRecord, K extends keyof T>(
  obj: T | null | undefined,
  key: K
): T[K] | undefined;
export function getSafely<
  T extends SafeRecord,
  K extends keyof T,
  D extends Exclude<T[K], undefined | null>,
>(obj: T | null | undefined, key: K, defaultValue: D): Exclude<T[K], undefined | null> | D;
export function getSafely<T extends SafeRecord, K extends keyof T, D extends T[K]>(
  obj: T | null | undefined,
  key: K,
  defaultValue: D
): T[K] | D;
export function getSafely<T extends SafeRecord, K extends keyof T, D extends T[K]>(
  obj: T | null | undefined,
  key: K,
  defaultValue?: D
): T[K] | D | undefined {
  if (
    (typeof key !== 'string' && typeof key !== 'number') ||
    DANGEROUS_KEYS.includes(key as (typeof DANGEROUS_KEYS)[number])
  ) {
    throw new Error(`Key cannot be accessed.`);
  }

  if (!obj || typeof obj !== 'object') {
    return defaultValue;
  }

  // Use hasOwnProperty to avoid prototype chain - key validated above for dangerous keys
  // eslint-disable-next-line eag/safe-object-access
  return Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : defaultValue;
}
